import * as yup from "yup";
import { testFloatAndMoney, testPositiveFloat } from "../../utils";

export const schema = yup.object().shape({
  id: yup.string().optional(),
  name: yup.string().required("Name is required"),
  description: yup.string().optional(),
  stockNumber: yup.string().required("Stock Number is required"),
  departmentId: yup.string().required("Department is required"),
  taxGroupId: yup.string().required("Tax Group is required"),
  categoryId: yup.string().optional(),
  locationId: yup.string().required("Location is required"),
  supplierId: yup.string().optional(),

  supplierStockCode: yup.string().when("supplierId", {
    is: (id: string) => id,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),

  costPrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Must be positive", testPositiveFloat as any)
    .required("Price is required"),
  retailPrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Must be positive", testPositiveFloat as any)
    .required("Retail Price is required"),
  costPriceExlTax: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Must be positive", testPositiveFloat as any)
    .required("Retail Price is required"),
  tradePrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Must be positive", testPositiveFloat as any)
    .required("Retail Price is required"),

  serialNumbersArr: yup.boolean().optional(),
  serialNumbersSale: yup.boolean().optional(),
  tags: yup.array().optional(),
  priceLookup: yup
    .string()
    .test("valid-plu", "PLU must start with a letter or ~", (value) => {
      return !value || /^[a-zA-Z~]/.test(value);
    })
    .optional(),

  weight: yup
    .string()
    .test("float", "Invalid Number", testPositiveFloat as any),

  UOM: yup.string().required(),

  selectedOptions: yup.array().optional(),
});

export const textButtonProps = {
  fontWeight: "bold",
  color: "action",
  variant: "body",
} as any;
